export default __webpack_public_path__ + "static/media/iterateIcon.baf17ee2.svg";